// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB77Yb1UgDrCvMiAtrF3DsA0HFbswj4FI0",
  authDomain: "cseutsav2022.firebaseapp.com",
  projectId: "cseutsav2022",
  storageBucket: "cseutsav2022.appspot.com",
  messagingSenderId: "936715333981",
  appId: "1:936715333981:web:a6285b887261805c0cb8b4",
  measurementId: "G-285MQQX1LL"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

const analytics = getAnalytics(app);

// Get a reference to the database service
export const database = getDatabase(app);